



















require('axios')
import { Component, Prop, Vue } from 'vue-property-decorator';
import NewApi, { BasePath } from '../ts/api';
import { DefaultApi, Image, Credentials } from '../api';


let api: DefaultApi;

@Component(
  {
    components:{

    }
  }
)
export default class Links extends Vue {
  credentials = {} as Credentials;
  imgs = [] as Image[];
  
  mounted(){
    api = NewApi()
  }

}
